'use client'

import { useState, useContext } from 'react'
import { Button } from '@/components/ui/shadcn/button'
import { Input } from '@/components/ui/shadcn/input'
import { Label } from '@/components/ui/shadcn/label'
import {
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/shadcn/dialog'
import { fetcher } from '@/lib/api/fetch'
import { AuthContext } from '@/contexts/AuthContext'
import { ManagerContext } from '@/contexts/ManagerContext'
import ErrorAlerts from '@/components/common/feedback/ErrorAlerts'

export default function CreateOrganization({ setOpen, changePage }) {
  const authContext = useContext(AuthContext)
  const context = useContext(ManagerContext)
  const [error, setError] = useState(null)
  const [errors, setErrors] = useState(null)
  const [loading, setLoading] = useState(false)

  if (!authContext.user.isAdmin) {
    return (
      <div className="flex flex-col gap-4">
        <DialogHeader>
          <DialogTitle>Access denied</DialogTitle>
          <DialogDescription>
            Only administrators can create new organizations.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => changePage('choose')}>
            Back
          </Button>
        </DialogFooter>
      </div>
    )
  }

  const submit = async e => {
    e.preventDefault()
    setLoading(true)

    const res = await fetcher(
      '/api/admin/organization',
      {
        method: 'POST',
        body: JSON.stringify({ name: e.target.name.value }),
      },
      authContext,
    )

    const data = await res.json()
    setLoading(false)

    if (res.ok) {
      setError(null)
      setErrors(null)

      authContext.setuser(
        {
          ...authContext.user,
          organization: data.organization,
        },
        () => {
          setOpen(false)
          window.location.replace('/manager/dashboard')
        },
      )
      context.addOrganization(data.organization)
    } else if (data.message) setError(data.message)
    else setErrors(data.messages)
  }

  return (
    <form onSubmit={submit} className="flex flex-col gap-4">
      <DialogHeader>
        <DialogTitle>Create an organization</DialogTitle>
        <DialogDescription>
          Set up a new organization to manage.
        </DialogDescription>
      </DialogHeader>

      <ErrorAlerts
        error={error}
        errors={errors}
        message="There is an issue with your submission:"
      />

      <div className="space-y-2">
        <Label htmlFor="organization-name">Organization name</Label>
        <Input
          id="organization-name"
          name="name"
          autoComplete="off"
          autoFocus
          required
        />
      </div>

      <DialogFooter>
        <Button
          type="button"
          variant="outline"
          onClick={() => changePage('choose')}
        >
          Choose existing
        </Button>
        <Button type="submit" disabled={loading}>
          {loading ? 'Creating...' : 'Create organization'}
        </Button>
      </DialogFooter>
    </form>
  )
}
